import React, { ReactNode } from "react";
import { Button, Group, Stepper as MantineStepper } from "@mantine/core";
import "./stepper.css";
import { WorkflowStep } from "../../utils/workflows.utils";
export interface StepperProps {
  data: WorkflowStep[];
  completed?: ReactNode;
  variant?: "default" | "textDown";
  page: number;
  isSubmitDisabled?: boolean;
  setPage: (page: number) => void;
  productIndex: number;
  workflowStepperUnfiltered: WorkflowStep[][] | null;
  setProductIndex: (productIndex: number) => void;
  isLoading?: boolean;
  onNext?: () => Promise<void>;
  onPrev?: () => void;
}

export const Stepper = ({ ...props }: StepperProps) => {
  const isCompletedOrLastStep =
    (props.completed && props.data.length === props.page) ||
    (!props.completed && props.data.length - 1 === props.page);

  const nextStep = async () => {
    if (
      (!isCompletedOrLastStep || props.isSubmitDisabled) &&
      !props.isLoading
    ) {
      // Call the parent's nextStep function directly instead of the workflow step's onNext
      if (props.onNext) {
        await props.onNext();
      }
    }
  };
  const prevStep = () => {
    // Use parent's onPrev function if provided
    if (props.onPrev) {
      props.onPrev();
      return;
    }

    const currentStep =
      props.workflowStepperUnfiltered[props.productIndex]?.[props.page];
    if (props.productIndex > 0 && props.page === 0) {
      const lastIndex =
        props.workflowStepperUnfiltered[props.productIndex - 1]?.length - 1;
      props.setProductIndex(props.productIndex - 1);
      return props.setPage(lastIndex);
    }
    return currentStep?.onPrev
      ? currentStep?.onPrev()
      : props.setPage(props.page > 0 ? props.page - 1 : props.page);
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        height: "100%",
        width: "100%",
      }}
    >
      <MantineStepper
        color="#3C61E3"
        active={props.page}
        classNames={
          props.variant === "textDown"
            ? {
                separator: "variant-separator",
                steps: "variant-steps",
                step: "variant-step",
                stepBody: "variant-step-body",
              }
            : undefined
        }
      >
        {props.data.map((step, index) => (
          <MantineStepper.Step
            key={index}
            label={step.label}
            description={step.description}
          >
            {step.component}
          </MantineStepper.Step>
        ))}
        <MantineStepper.Completed>{props.completed}</MantineStepper.Completed>
      </MantineStepper>

      <Group justify="space-between" mt="xl" align="end">
        {(props.page > 0 || props.productIndex > 0) && (
          <Button
            color="#3C61E3"
            variant="outline"
            onClick={prevStep}
            data-testid="step-button-previous"
          >
            Précédent
          </Button>
        )}
        {props.page === 0 && <div></div>}
        {isCompletedOrLastStep && !props.isSubmitDisabled && (
          <Button
            color="green"
            type="submit"
            data-testid="step-button-validate"
          >
            Valider ma commande
          </Button>
        )}
        {(!isCompletedOrLastStep || props.isSubmitDisabled) && (
          <Button
            color="#3C61E3"
            onClick={nextStep}
            type="button"
            data-testid="step-button-next"
            disabled={props.isLoading}
          >
            {props.isLoading ? "Chargement..." : "Suivant"}
          </Button>
        )}
      </Group>
    </div>
  );
};
